module.exports = __webpack_require__.p + "5e05ef93e36341980018ced08b405fb3.png";